<template>
    <div class="parkingPay flex-column">
        <div class="parkingPay-content">
            <div class="parkingPay-carInfo">
                <div class="parkingPay-carInfo-header flex align-center justify-between">
                    <span>{{ carInfo.plateNum }}</span>
                    <img src="@/assets/images/pay/parkingPay-money.png" alt="" />
                </div>
                <div class="parkingPay-carInfo-content">
                    <div class="carInfo-content-header">{{ carInfo.parkName }}</div>
                    <div v-if="carInfo.parkType == 1" class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-number.png" alt="" />
                        <p class="carInfo-content-item-title">泊位号</p>
                        <p class="carInfo-content-item-value">{{ carInfo.stallCode }}</p>
                    </div>
                    <div class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parkingPay-long.png" alt="" />
                        <p class="carInfo-content-item-title">驶入时间</p>
                        <p class="carInfo-content-item-value">{{ carInfo.inTime }}</p>
                    </div>
                    <div class="carInfo-content-item flex align-center">
                        <img class="carInfo-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                        <p class="carInfo-content-item-title">停车时长</p>
                        <p class="carInfo-content-item-value" style="color: #009af3">{{ secondToMinute(carInfo.parkingTime) }}分钟</p>
                    </div>
                </div>
                <div class="parkingPay-billInfo">
                    <div class="parkingPay-billInfo-header">
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">停车费用</p>
                            <p class="parkingPay-billInfo-item-value1">{{ Number(carInfo.consume).toFixed(2) }}元</p>
                        </div>
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">已支付</p>
                            <p class="parkingPay-billInfo-item-value2">{{ Number(carInfo.realPay).toFixed(2) }}元</p>
                        </div>
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">还需支付</p>
                            <p class="parkingPay-billInfo-item-value2">{{ Number(carInfo.orderMoney).toFixed(2) }}元</p>
                        </div>
                        <div class="parkingPay-billInfo-item flex align-center justify-between">
                            <p class="parkingPay-billInfo-item-title">支付金额</p>
                            <p class="parkingPay-billInfo-item-value3">{{ Number(carInfo.realMoney).toFixed(2) }}元</p>
                        </div>
                    </div>
                </div>
                <div class="parkingPay-billInfo-divider">
                    <div class="parkingPay-billInfo-divider-line">
                        <van-divider dashed></van-divider>
                    </div>
                </div>

                <div class="parkingPay-wave-wrap">
                    <div class="parkingPay-billInfo-footer-wave"></div>
                </div>
            </div>
        </div>
        <div class="parkingPay-comfirm-btn">
            <van-button :loading="payLoading" @click="payNow" class="comfirm-btn">立即缴费</van-button>
        </div>

        <loading :show="payLoading" text="支付中..." />
    </div>
</template>

<script>
import { secondToMinute, throttleBytimestamp, obj2Param } from "@/libs/tools";
import Loading from "@/components/base/loading/loading.vue";
import { payEnv } from "@/libs/tools";

import { queryMyParkingRecordDetail, submitParkingOrderFromApp } from "@/api/apiNoAuth";
export default {
    name: "ParkingunionPay",
    components: {
        Loading,
    },
    data() {
        return {
            carInfo: {},
            couponMoney: 0, //优惠券金额X
            payType: "2", // 1:余额支付，2：微信支付
            payLoading: false, //支付遮罩
            payStatus: 0,
            obj: {},
        };
    },

    mounted() {
        this.obj = this.$route.query;
        this.payStatus = this.obj.payStatus;

        queryMyParkingRecordDetail(this.obj).then((res) => {
            this.carInfo = res.data;
        });
    },
    methods: {
        secondToMinute,
        payNow: throttleBytimestamp(function () {
            let { payChannel, appEnv } = payEnv();
            const requestObj = {
                payChannel: payChannel,
                business: "normalpay",
                parkType: this.carInfo.parkType,
                totalRealMoney: this.carInfo.realMoney,
                certId: this.carInfo.plateNum,
                orderInfo: [
                    {
                        buyer: this.carInfo.plateNum,
                        parkCode: this.carInfo.parkCode,
                        plateNum: this.carInfo.plateNum,
                        stallCode: this.carInfo.stallCode,
                        arrearsType: this.carInfo.arrearsType,
                        orderMoney: this.carInfo.orderMoney,
                        couponMoney: this.carInfo.couponMoney,
                        realMoney: this.carInfo.realMoney,
                        couponDetailId: this.carInfo.couponDetailId,
                        couponRandomId: this.carInfo.couponRandomId,
                        couponTicketMoney: this.carInfo.couponTicketMoney,
                        couponRandomMoney: this.carInfo.couponRandomMoney,
                        payForMoney: this.carInfo.payForMoney,
                        parkingRecordId: this.carInfo.parkingRecordId,
                        goodSubject: this.carInfo.parkType === 1 ? `路内停车${appEnv}缴费` : `路外停车${appEnv}缴费`,
                        goodDetail: this.carInfo.parkType === 1 ? `路内停车${appEnv}缴费` : `路外停车${appEnv}缴费`,

                        //扫码
                        scanDiscount: this.carInfo.scanDiscount,
                        scanDiscountConfigId: this.carInfo.scanDiscountConfigId,
                    },
                ],
            };
            this.payLoading = true;
            submitParkingOrderFromApp(requestObj)
                .then((res) => {
                    window.location = res.data.payUrl;
                })
                .finally(() => {
                    this.payLoading = false;
                });
        }, 2000),
    },
};
</script>

<style lang="less" scoped>
.no-coupon {
    margin-left: auto;
    color: #fff;
    font-size: 24px;
    border-radius: 40px;
    background-color: #ff0000;
    padding: 0 10px;
}
.parkingPay {
    .parkingPay-content {
        height: calc(~"100vh - 88px - 40px");
        padding: 12px;
        overflow: auto;

        .parkingPay-carInfo {
            width: 726px;
            height: 366px;
            background: url("~@/assets/images/pay/parkingPay-header.png")
                no-repeat;
            background-size: 100% 100%;
            .parkingPay-carInfo-header {
                width: 100%;
                height: 90px;
                padding: 24px 44px 27px;

                span {
                    font-size: 40px;
                    font-weight: 500;
                    color: #fcfcfc;
                }

                img {
                    width: 27px;
                    height: 37px;
                }
            }

            .parkingPay-carInfo-content {
                // flex: 1;
                height: 266px;
                padding: 24px 44px 27px;

                .carInfo-content-header {
                    font-size: 32px;
                    font-weight: 500;
                    color: #212121;
                    margin-bottom: 30px;
                }

                .carInfo-content-item {
                    margin-bottom: 16px;

                    .carInfo-content-item1 {
                        width: 24px;
                        height: 24px;
                    }

                    .carInfo-content-item2 {
                        width: 24px;
                        height: 28px;
                    }

                    .carInfo-content-item-title {
                        margin-left: 17px;
                        vertical-align: top;
                    }

                    .carInfo-content-item-value {
                        margin-left: auto;
                        color: #666666;
                    }
                }
            }

            .parkingPay-billInfo {
                width: 702px;
                background-color: #fff;
                margin: 0 auto;
                padding: 26px;

                .parkingPay-billInfo-header {
                    .parkingPay-billInfo-item {
                        margin-bottom: 16px;

                        .parkingPay-billInfo-item-title {
                            font-size: 30px;
                            color: #212121;
                        }

                        .parkingPay-billInfo-item-value1 {
                            color: #009af3;
                            font-size: 40px;
                        }

                        .parkingPay-billInfo-item-value2 {
                            color: #616161;
                            font-size: 30px;
                        }

                        .parkingPay-billInfo-item-value3 {
                            color: #212121;
                            font-size: 40px;
                        }
                    }

                    .parkingPay-billInfo-coupon {
                        margin-top: 20px;

                        .parkingPay-billInfo-img {
                            width: 28px;
                            height: 28px;
                            margin-right: 13px;
                        }

                        color: #666666;
                        font-size: 28px;

                        .parkingPay-billInfo-coupon-right {
                            margin-left: auto;
                            font-size: 28px;

                            img {
                                width: 12px;
                                height: 21px;
                                margin-left: 26px;
                            }
                        }
                    }
                }
            }

            .parkingPay-billInfo-divider {
                width: 702px;
                height: 30px;
                background-color: #ffffff;
                margin: 0 auto;
                position: relative;

                .parkingPay-billInfo-divider-line {
                    width: 640px;
                    position: absolute;
                    top: 14px;
                    left: 30px;
                }

                &::after {
                    position: absolute;
                    content: "";
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background-color: #f5f8fa;
                    left: -15px;
                    top: 0;
                }

                &::before {
                    position: absolute;
                    content: "";
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    background-color: #f5f8fa;
                    right: -15px;
                    top: 0;
                }
            }

            .parkingPay-billInfo-footer {
                width: 702px;
                margin: 0 auto;
                padding: 26px;
                background-color: #fff;

                .parkingPay-billInfo-payType-text {
                    font-size: 30px;
                    color: #333333;
                }

                .parkingPay-footer-type {
                    img {
                        width: 40px;
                        height: 38px;
                        margin-right: 17px;
                    }

                    .parkingPay-footer-payforpocket {
                        color: #666666;
                        font-size: 28px;

                        .parkingPay-pocket-balance {
                            color: #999;
                            font-size: 24px;
                        }
                    }
                }
            }
            .parkingPay-wave-wrap {
                width: 702px;
                height: 80px;
                margin: auto;
                // background-color: red;
                position: relative;
                .parkingPay-billInfo-footer-wave {
                    width: 702px;
                    height: 30px;
                    position: absolute;
                    top: -16px;
                    background: radial-gradient(
                            circle at 50% 50%,
                            #f5f8fa 0,
                            #f5f8fa 50%,
                            transparent 0
                        ),
                        radial-gradient(
                            circle at 50% 50%,
                            #f5f8fa 0,
                            #f5f8fa 50%,
                            transparent 0
                        );
                    background-repeat: repeat-x;
                    // background-color: #fff ;
                    background-size: 30px 30px;
                    background-position: bottom;
                }
            }
        }
    }
    .parkingPay-comfirm-btn {
        width: 750px;
        height: 122px;
        margin-top: auto;
        text-align: center;
        background-color: #fff;
        color: #fff;
    }
}
</style>
<style lang="less">
.parkingPay-billInfo-divider {
    .van-divider {
        margin: 0;
    }
}

.parkingPay-billInfo-footer {
    .van-cell {
        padding: 10px 0;
    }
}
</style>
